var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},[_c('i',{staticClass:"fa fa-caret-right fa-1x color-primary"}),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"button-bar"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }